module.exports = __webpack_public_path__ + "img/600-image-5.eed2e214.png";